<template>
    <common-modal width="medium" @emitEvent="emitEvent($event, ['close'])" @close="emitEvent({ name: 'close' })">
        <div class="error-modal-container">
            <div>
                <img class="notification-icon" :src="loadErrorIcon" />
            </div>
            <p class="header">
                {{
                    $t('pages.administrator.claim_your_profile.claim_your_profile_modal.heading', {
                        failedEmailsCount: emailErrorList.length,
                        totalEmailsCount: totalEmailsCount,
                    })
                }}
            </p>
            <div class="content">
                <div v-for="(item, index) in emailErrorList" :key="index" class="connections-widget__item item">
                    <p>
                        {{ item.email }} |
                        <strong>{{ item.error }}</strong>
                    </p>
                </div>
            </div>
            <common-button
                v-if="defaultCloseButtonEnabled"
                :label="$t('modals.send_join_invites_modal_check_emails.close_button')"
                type="primary"
                size="large"
                :isSubmittable="false"
                @click="emitEvent({ name: 'close' })"
            ></common-button>
        </div>
    </common-modal>
</template>

<script>
    export default {
        props: {
            emailErrorList: { type: Array, required: true },
            defaultCloseButtonEnabled: { type: Boolean, default: true },
            totalEmailsCount: { type: Number, required: true },
        },

        computed: {
            loadErrorIcon: function () {
                return require('../../../../images/error-icon.svg').default
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/components/page-elements/admin-panel/_claim-your-profile-error-modal';
</style>
